import { render, staticRenderFns } from "./_ChannelStyles.vue?vue&type=template&id=477c2bbe&"
import script from "./_ChannelStyles.vue?vue&type=script&lang=ts&"
export * from "./_ChannelStyles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports